<template>
  <div class="configure">
    <el-card>
      <h4 class="card-title">配置图谱</h4>
      <el-row v-if="updatePriv">
        <el-col :span="16" :offset="4" v-loading="isLoading">
          <el-steps :active="activeStep - 1" finish-status="success">
            <el-step title="设置能力指标"></el-step>
            <el-step title="关联主题与活动"></el-step>
            <el-step title="确定能力图谱"></el-step>
          </el-steps>
          <div class="button-group my-3 text-center">
            <el-button
              v-if="activeStep < 3"
              type="primary"
              size="medium"
              @click="submitForm(2)"
              :disabled="activeStep === 3"
              >下一步</el-button
            >
            <el-button
              :class="{ 'btn-outline': activeStep !== 3 }"
              v-if="activeStep > 1"
              type="primary"
              :plain="activeStep !== 3"
              size="medium"
              @click="submitForm(activeStep === 3 ? 2 : 0)"
              >{{ activeStep === 3 ? '确认' : '保存' }}</el-button
            >
            <el-button
              class="btn-outline"
              type="primary"
              size="medium"
              plain
              @click="submitForm(1)"
              v-if="activeStep > 1"
              >返回上一步</el-button
            >
          </div>
          <el-form v-if="activeStep === 1" :model="ruleForm" ref="ruleForm" label-width="120px" class="configure-form">
            <el-form-item label="设置方式" prop="method" style="margin-bottom: 0">
              <el-radio-group
                v-model="frameSettingMethod"
                @change="handleChangeFrameSettingMethod"
                :disabled="!canUpdateFrame"
              >
                <el-radio :label="1">新建能力框架</el-radio>
                <el-radio :label="2">引用已有能力框架</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="" prop="method" v-if="frameSettingMethod === 1">
              <el-button type="primary" size="small" @click="handleToAiBox">AI生成能力框架</el-button>
            </el-form-item>
            <el-form-item v-if="!disabledEdit" label="能力框架名称" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <template v-else>
              <el-form-item label="已有能力框架" prop="name">
                <div class="flex">
                  <el-select
                    style="flex: 1"
                    v-model="ruleForm.id"
                    placeholder="请选择"
                    @change="getCapabilityFrameDetail"
                    :disabled="!canUpdateFrame"
                  >
                    <el-option
                      v-for="frame in abilityFrameworkList"
                      :key="frame.id"
                      :label="frame.name"
                      :value="frame.id"
                    ></el-option>
                  </el-select>
                  <el-button class="btn-edit ml-2" type="text" @click="editAbilityName" v-if="canUpdateFrame"
                    >去修改</el-button
                  >
                </div>
                <div class="text-grey">创建者：{{ frameworkCreator }}</div>
              </el-form-item>
            </template>
            <template v-if="frameSettingMethod === 1">
              <el-form-item
                v-for="(target, index) in ruleForm.list"
                :label="'L' + (index + 1)"
                :key="target.key"
                class="form-item-border"
              >
                <el-form-item class="form-item-target-name" label="指标名称">
                  <el-input v-model="target.indicator_name" :disabled="disabledEdit"></el-input>
                  <el-button class="btn-remove" type="text" @click="removeTarget(target)" v-if="!disabledEdit"
                    >删除</el-button
                  >
                </el-form-item>
                <el-form-item label="指标描述">
                  <el-input
                    class="mb-2"
                    type="textarea"
                    :disabled="disabledEdit"
                    v-model="target.description"
                  ></el-input>
                </el-form-item>
                <el-form-item label="评价指标">
                  <el-select
                    style="width: 100%"
                    v-model="target.level_id"
                    placeholder="请选择评价指标"
                    @change="(val) => handleChangeLevel(val, index)"
                    :disabled="disabledEdit"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.id"
                      v-for="(item, _index) in evaluateList"
                      :key="_index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="指标评语">
                  <div class="flex comment-wrapper mb-2" v-for="(comment, _index) in target.content" :key="_index">
                    <div class="flex-left">
                      {{ comment.tier }}、{{ comment.max }}~{{ comment.min
                      }}<template v-if="comment.alias">({{ comment.alias }})</template>
                    </div>
                    <div class="flex-right">
                      <el-input
                        v-model="comment.evaluation"
                        :disabled="disabledEdit"
                        placeholder="请输入内容"
                      ></el-input>
                    </div>
                  </div>
                </el-form-item>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item label="课程所属专业" prop="major" required>
                <el-select style="width: 100%" v-model="ruleForm.major" multiple placeholder="请选择专业" filterable>
                  <el-option v-for="item in majorList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="课程所属年级" prop="grade" required>
                <el-select multiple style="width: 100%" v-model="ruleForm.grade" placeholder="请选择年级" filterable>
                  <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <el-form-item v-if="!disabledEdit">
              <el-button type="primary" size="medium" @click="addTarget" v-if="ruleForm.list.length < 8"
                >新增指标</el-button
              >
              <!-- <div class="text-small">注意：不启用的指标请留空</div> -->
            </el-form-item>
          </el-form>
          <el-form v-if="activeStep === 2" ref="indicatorFrom" :model="indicatorFrom" :rules="rules">
            <template v-for="(indicatorItem, indicatorIndex) in indicatorFrom.indicatorList">
              <el-form-item class="form-item-border" :label="'L' + (indicatorIndex + 1)" :key="indicatorIndex">
                <div class="flex flex-between">
                  <div class="flex-left font-bold">{{ indicatorItem.indicator_name }}</div>
                  <div class="flex-right">
                    <el-button type="primary" size="medium" @click="relatedTopic(indicatorIndex)">关联主题</el-button>
                  </div>
                </div>
              </el-form-item>
              <el-table
                border
                :data="indicatorItem.section"
                :span-method="(e) => objectSpanMethod(e, indicatorItem.section)"
                class="table-indicator mb-3"
                :key="'table-' + indicatorIndex"
                v-if="indicatorItem.section.length > 0"
              >
                <el-table-column label="主题汇算" width="110" class-name="table-column-center">
                  <template slot-scope>
                    <el-checkbox v-model="indicatorItem.avg_section" :true-label="1" :false-label="0">平均</el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot="header"> <span style="color: red">*</span>主题 </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :label="scope.row.name"
                      :prop="'indicatorList.' + indicatorIndex + '.section.' + scope.$index + '.weight'"
                      :rules="rules.sectionItem"
                    >
                      <span v-if="indicatorItem.avg_section" style="padding-right: 10px;">- %</span>
                      <el-input style="width: 90px" v-model="scope.row.weight" placeholder="请输入" v-else>
                        <span slot="suffix">%</span>
                      </el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="活动汇算" width="110" class-name="table-column-center">
                  <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.avg_activity" :true-label="1" :false-label="0">平均</el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot="header"> <span style="color: red">*</span>评价项 </template>
                  <template slot-scope="scope">
                    <el-form-item
                      v-for="(activityItem, index) in scope.row.activity"
                      :key="index"
                      :label="activityItem.name"
                      :prop="
                        'indicatorList.' +
                        indicatorIndex +
                        '.section.' +
                        scope.$index +
                        '.activity.' +
                        index +
                        '.weight'
                      "
                      :rules="rules.activityName"
                    >
                      <span v-if="scope.row.avg_activity" style="padding-right: 10px;">- %</span>
                      <el-input v-model="activityItem.weight" placeholder="请输入" style="width: 90px" v-else>
                        <span slot="suffix">%</span>
                      </el-input>
                    </el-form-item>
                    <div class="text-center">
                      <el-button
                        type="text"
                        size="medium"
                        icon="el-icon-circle-plus"
                        @click="addEvaluationItem(indicatorIndex, scope)"
                        >添加评价项</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-form>
          <div class="preview-ability" v-if="activeStep === 3">
            <el-form label-position="left" label-width="230px" style="padding: 0 10%">
              <el-form-item label="是否显示在课程主页得顶部板块">
                <el-select style="width: 100%" v-model="previewForm.show_mdl" placeholder="请选择">
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <target-detail :form="previewForm" :show-title-bg="true"></target-detail>
          </div>
          <div class="button-group my-3 text-center">
            <el-button
              v-if="activeStep < 3"
              type="primary"
              size="medium"
              @click="submitForm(2)"
              :disabled="activeStep === 3"
              >下一步</el-button
            >
            <el-button
              :class="{ 'btn-outline': activeStep !== 3 }"
              v-if="activeStep > 1"
              type="primary"
              :plain="activeStep !== 3"
              size="medium"
              @click="submitForm(activeStep === 3 ? 2 : 0)"
              >{{ activeStep === 3 ? '确认' : '保存' }}</el-button
            >
            <el-button
              class="btn-outline"
              type="primary"
              size="medium"
              plain
              @click="submitForm(1)"
              v-if="activeStep > 1"
              >返回上一步</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-empty v-else-if="privChecked" description="您没有权限修改该课程信息"></el-empty>
    </el-card>
    <el-dialog title="关联主题" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false">
      <el-row>
        <el-col :span="14">
          <el-radio-group v-model="radioSection" size="small" @change="handleChangeSectionRadio">
            <el-radio-button label="1">课程主题</el-radio-button>
            <el-radio-button label="2">自定义主题</el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col :span="10" style="text-align: right" v-if="radioSection === '2'">
          <el-button type="primary" size="small" @click="handleAddSection">添加主题</el-button>
        </el-col>
      </el-row>
      <el-table :data="sectionList" border ref="multipleTopicTable" @selection-change="handleSelectionChangeTopic">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="name" label="主题名称"></el-table-column>
        <el-table-column prop="name" label="操作栏" v-if="radioSection === '2'" width="120px">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEditSection(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleDeleteSection(scope.row)"
              ><span style="color: red">删除</span></el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        width="30%"
        :title="customSectionForm.id ? '编辑主题' : '新增主题'"
        :visible.sync="addCustomSectionDialogVisible"
        :close-on-click-modal="false"
        append-to-body
      >
        <el-form
          :model="customSectionForm"
          :rules="customSectionFormRules"
          ref="addCustomSectionFormRef"
          label-width="80px"
        >
          <el-form-item label="主题名称" prop="name">
            <el-input v-model="customSectionForm.name" @keydown.native="handleEnter"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleCloseAddSectionDialog">取消</el-button>
          <el-button type="primary" @click="handleAddSectionConfirm">确认</el-button>
        </span>
      </el-dialog>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseTopicDialog">取消</el-button>
        <el-button type="primary" @click="confirmRelatedTopic">确认关联</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加评价项" :visible.sync="dialogEvaluateVisible" width="50%" :close-on-click-modal="false">
      <!-- <MultipleSelectTable :tableData="tableActivityData"></MultipleSelectTable> -->
      <el-form label-width="80px">
        <el-form-item label="评价项">
          <el-cascader
            v-model="checkedActivities"
            :props="evaluateProps"
            style="width: 100%"
            placeholder="请输入评价项"
            :options="tableActivityData"
            filterable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseEvaluateDialog">取消</el-button>
        <el-button type="primary" @click="confirmRelatedEvaluate">确认添加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TargetDetail from '@/components/ability/TargetDetail.vue'
import { handleTreeData, flattenTree } from '@/utils/commom.js'
import { domainName } from '@/config/setting.js'
export default {
  name: 'Configure',
  components: {
    TargetDetail,
    // MultipleSelectTable,
  },
  props: {
    courseInfo: {
      type: Object,
      default: () => ({}),
    },
    updatePriv: {
      // 是否有当前课程的图谱配置权限，由父级页面校验后传入
      type: Boolean,
      default: false,
    },
    privChecked: {
      // 权限接口是否已返回，由父级页面传入
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      courseId: '',
      activeStep: 1,
      abilityFrameworkList: [],
      evaluateList: [], // 评价指标列表
      frameSettingMethod: 1,
      isLoading: false,
      frameworkCreator: '', // 框架创建者
      indexId: '', // 用来记住切换新建和引用时的id
      ruleForm: {
        name: '',
        major: [],
        grade: [],
        list: [],
      },
      rules: {
        // sectionItem: [
        //   {
        //     required: true,
        //     validator: (rule, value, callback) => {
        //       if (value === '') {
        //         callback(new Error('请输入权重'))
        //       } else if (value < 0 || value > 100) {
        //         callback(new Error('权重必须在0-100之间'))
        //       } else if (value >= 0 && value <= 100) {
        //         callback()
        //       } else {
        //         callback('权重值不合法')
        //       }
        //     },
        //     trigger: 'blur',
        //   },
        // ],
        // activityName: [
        //   {
        //     required: true,
        //     validator: (rule, value, callback) => {
        //       if (value === '') {
        //         callback(new Error('请输入权重'))
        //       } else if (value < 0 || value > 100) {
        //         callback(new Error('权重必须在0-100之间'))
        //       } else if (value >= 0 && value <= 100) {
        //         callback()
        //       } else {
        //         callback('权重值不合法')
        //       }
        //     },
        //     trigger: 'blur',
        //   },
        // ],
      },
      indicatorFrom: {
        indicatorList: [],
      },
      dialogVisible: false,
      radioSection: '1',
      sectionList: [],
      multipleTopicSelection: [],
      customSectionForm: {
        name: '',
      },
      customSectionFormRules: {
        name: [
          {
            required: true,
            message: '请输入主题名称',
            trigger: 'blur',
          },
        ],
      },
      addCustomSectionDialogVisible: false, // 新增/编辑自定义主题弹窗
      dialogEvaluateVisible: false,
      indicatorItemDataIndex: 0,
      sectionItemDataIndex: 0,
      tableActivityData: [],
      checkedActivities: [],
      multipleEvaluateSelection: [],
      previewForm: {
        show_mdl: 1,
        list: [],
      },
      evaluateProps: {
        multiple: true,
        emitPath: false,
        label: 'name',
        value: 'id',
      },
      canUpdateFrame: false, // 是否可修改能力框架
      sesskey: '',
      majorList: [],
      gradeList: [],
    }
  },
  computed: {
    disabledEdit() {
      return this.frameSettingMethod === 2
    },
  },
  watch: {
    $route: {
      handler: function () {
        this.courseId = this.$route.query.courseId
        this.sesskey = this.$route.query.sesskey
      },
      immediate: true,
    },
    // 权限由父级页面校验后传入，拿到权限后再加载配置数据
    updatePriv: {
      handler(val) {
        if (!val) {
          return
        }
        this.getCapabilityConfiguration()
        if (this.$route.query.step === '2') {
          this.activeStep = 2
          this.getCapabilityStep2()
        } else {
          this.getCapabilityStep1()
        }
      },
      immediate: true,
    },
  },
  methods: {
    objectSpanMethod({ rowIndex, columnIndex }, sectionList) {
      if (columnIndex === 0) {
        if (rowIndex % sectionList.length === 0) {
          return {
            rowspan: sectionList.length,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    nextStep() {
      this.activeStep++
      this.handleFetchStepData()
    },
    lastStep() {
      this.activeStep--
      this.handleFetchStepData()
    },
    handleToAiBox() {
      window.location.href = `${domainName}/local/ai_box/web/index.php?courseid=${
        this.courseId
      }&appType=3&callback=${encodeURIComponent(
        `${domainName}/ability/#/ability-graph/detail/configure?courseId=${this.courseId}`
      )}`
    },
    handleFetchStepData() {
      if (this.activeStep === 1) {
        this.getCapabilityStep1()
      } else if (this.activeStep === 2) {
        this.getCapabilityStep2()
      } else if (this.activeStep === 3) {
        this.getCapabilityStep3()
      }
    },
    handleChangeFrameSettingMethod(val) {
      if (val === 1) {
        this.ruleForm = { name: `${this.$store.state.course?.courseInfo?.fullname || ''}能力框架`, list: [] }
      } else {
        this.getCapabilityStep1(true)
      }
    },
    // 获取配置1信息
    getCapabilityStep1(isChangeRadio = false) {
      this.isLoading = true
      this.$store
        .dispatch('capability/getCapabilityStep1', { course_id: this.courseId })
        .then((res) => {
          if (res.code === 1) {
            this.ruleForm.id = res.data.index_id || ''
            if (isChangeRadio && this.indexId) {
              this.ruleForm.id = this.indexId
            } else {
              this.indexId = this.ruleForm.id
            }
            if (this.ruleForm.id) {
              this.frameSettingMethod = 2
              this.ruleForm.major = res.data.major || []
              this.ruleForm.grade = res.data.grade || []
              this.frameworkCreator = res.data.user_nickname || ''
            } else if (!isChangeRadio) {
              this.frameSettingMethod = 1
            }
            this.canUpdateFrame = !!res.data.can_update
            if (this.canUpdateFrame) {
              this.getCapabilityFrameAll()
            } else {
              this.abilityFrameworkList = [{ id: res.data?.index_id, name: res.data?.index_name }]
            }
            if (this.ruleForm.id) {
              this.getCapabilityFrameDetail()
            } else {
              this.ruleForm.name = `${this.$store.state.course?.courseInfo?.fullname}能力框架`
            }
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    // 获取配置2信息
    getCapabilityStep2() {
      this.frameSettingMethod = 1
      this.isLoading = true
      this.$store
        .dispatch('capability/getCapabilityStep2', { course_id: this.courseId })
        .then((res) => {
          if (res.code === 1) {
            this.indicatorFrom.indicatorList =
              res.data.map((item) => {
                return {
                  ...item,
                  avg_section: item.avg_section === 1 ? 1 : 0,
                  section: item.section.map((sectionItem) => {
                    return {
                      ...sectionItem,
                      avg_activity: sectionItem.avg_activity === 1 ? 1 : 0,
                      type: sectionItem.type || 1,
                    }
                  }),
                }
              }) || []
            console.log('indicatorList::', this.indicatorFrom.indicatorList)
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    // 获取配置3信息
    getCapabilityStep3() {
      this.isLoading = true
      this.$store
        .dispatch('capability/getCapabilityStep3', { course_id: this.courseId })
        .then((res) => {
          console.log('getCapabilityStep3:', res)
          if (res.code === 1) {
            this.previewForm = res.data
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    // 获取全部能力框架列表
    getCapabilityFrameAll() {
      this.$store
        .dispatch('capability/getCapabilityFrameAll')
        .then((res) => {
          if (res.code === 1) {
            this.abilityFrameworkList = res.data || []
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    getCapabilityFrameDetail() {
      this.$store
        .dispatch('capability/getCapabilityFrameDetail', this.ruleForm.id)
        .then((res) => {
          if (res.code === 1) {
            let major = this.ruleForm.major || []
            let grade = this.ruleForm.grade || []
            this.ruleForm = {
              ...res.data,
              major,
              grade,
            }
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    getCapabilityConfiguration() {
      this.$store
        .dispatch('capability/getCapabilityConfiguration')
        .then((res) => {
          if (res.code === 1) {
            this.evaluateList = res.data
            this.getCapabilityMajorAll()
            this.getCapabilityGradeAll()
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    getCapabilityMajorAll() {
      this.$store
        .dispatch('capability/getCapabilityMajorAll')
        .then((res) => {
          if (res.code === 1) {
            this.majorList = res.data.map((item, index) => {
              return {
                id: index,
                name: item,
              }
            })
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    getCapabilityGradeAll() {
      this.$store
        .dispatch('capability/getCapabilityGradeAll')
        .then((res) => {
          if (res.code === 1) {
            this.gradeList = res.data.map((item, index) => {
              return {
                id: index,
                name: item,
              }
            })
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    // 评价指标联动指标评语
    handleChangeLevel(val, index) {
      this.ruleForm.list[index].content =
        this.evaluateList
          .find((item) => item.id === val)
          ?.content.map((_) => {
            return {
              ..._,
              evaluation: _.default || '',
            }
          }) || []
    },
    // 获取课程关联主题
    getCapabilityConfigurationSection() {
      this.$store
        .dispatch('capability/getCapabilityConfigurationSection', { course_id: this.courseId })
        .then((res) => {
          console.log('getCapability ConfigurationSection:', res)
          if (res.code === 1) {
            this.sectionList = res.data || []
            this.setTableSelection()
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    // 获取课程自定义主题
    getCapabilitySectionList() {
      this.$store.dispatch('capability/getCapabilitySectionList', { course_id: this.courseId }).then((res) => {
        if (res.code === 1) {
          console.log('getCapability SectionList', res)
          this.sectionList = res.data || []
          this.setTableSelection()
        }
      })
    },
    setTableSelection() {
      setTimeout(() => {
        this.indicatorFrom.indicatorList[this.indicatorItemDataIndex].section.map((item) => {
          let row = this.sectionList.find((v) => v.id == item.section_id)
          console.log('row', row)
          row && this.$refs.multipleTopicTable.toggleRowSelection(row)
        })
      }, 100)
    },
    handleAddSection() {
      this.addCustomSectionDialogVisible = true
      this.customSectionForm.name = ''
    },
    handleEditSection(row) {
      this.customSectionForm.id = row.id
      this.customSectionForm.name = row.name
      this.addCustomSectionDialogVisible = true
    },
    handleDeleteSection(row) {
      this.$confirm('确认删除该主题?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$store
            .dispatch('capability/deleteCapabilitySection', {
              course_id: this.courseId,
              id: row.id,
            })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success('删除成功')
                this.getCapabilitySectionList()
              }
            })
            .catch((err) => {
              console.log('err:', err)
            })
        })
        .catch(() => {})
    },
    handleCloseAddSectionDialog() {
      this.addCustomSectionDialogVisible = false
    },
    handleAddSectionConfirm() {
      this.$refs.addCustomSectionFormRef.validate((valid) => {
        if (valid) {
          this.$store
            .dispatch('capability/saveCapabilitySection', {
              id: this.customSectionForm.id,
              name: this.customSectionForm.name,
              course_id: this.courseId,
            })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success('添加成功')
                this.addCustomSectionDialogVisible = false
                this.customSectionForm.id = ''
                this.customSectionForm.name = ''
                this.getCapabilitySectionList()
              }
            })
            .catch((err) => {
              console.log('err:', err)
            })
        } else {
          return false
        }
      })
    },
    // 获取关联活动
    getCapabilityConfigurationActivity() {
      this.$store
        .dispatch('capability/getCapabilityConfigurationActivity', { course_id: this.courseId })
        .then((res) => {
          const _this = this
          console.log('getCapabilityConfigurationActivity:', res)
          if (res.code === 1) {
            const checkCondition = (node) => {
              let templist =
                _this.indicatorFrom.indicatorList[this.indicatorItemDataIndex].section[this.sectionItemDataIndex]
                  .activity
              return templist.some((_) => _.id === node.id)
            }
            this.tableActivityData = handleTreeData(res.data?.children || [], '0', checkCondition)
            console.log('tableActivityData', this.tableActivityData)
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    submitForm(stepType) {
      if (this.activeStep === 1) {
        this.submitStepStep1(stepType)
      } else if (this.activeStep === 2) {
        this.submitStepStep2(stepType)
      } else if (this.activeStep === 3) {
        this.submitStepStep3(stepType)
      }
    },
    submitStepStep1(stepType) {
      let params = {
        course_id: this.courseId,
        is_submit: 1,
        mode: this.frameSettingMethod,
      }
      if (this.frameSettingMethod === 1) {
        params.name = this.ruleForm.name
        params.list = this.ruleForm.list.map((item) => {
          return {
            indicator_name: item.indicator_name,
            description: item.description,
            level_id: item.level_id,
            content: item.content.map((_) => {
              return {
                tier: _.tier,
                evaluation: _.evaluation,
              }
            }),
          }
        })
      } else {
        params.index_id = this.ruleForm.id
        params.major = this.ruleForm.major
        params.grade = this.ruleForm.grade
      }
      this.$store
        .dispatch(`capability/submitCapabilityStep1`, params)
        .then((res) => {
          console.log('res:', res)
          if (res.code === 1) {
            this.$message.success('保存成功')
            if (this.frameSettingMethod === 1) {
              this.frameSettingMethod = 2
              this.getCapabilityStep1()
            } else if (stepType === 2) {
              this.nextStep()
            } else {
              this.getCapabilityStep1()
            }
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    submitStepStep2(stepType) {
      let params = {
        course_id: this.courseId,
        is_submit: stepType === 2 ? 1 : 0,
        list: this.indicatorFrom.indicatorList.map((item) => {
          return {
            sort: item.sort,
            indicator_name: item.indicator_name,
            avg_section: item.avg_section,
            section: item.section.map((section) => {
              return {
                type: section.type || 1,
                section_id: section.section_id,
                weight: section.weight,
                avg_activity: section.avg_activity,
                activity: section.activity.map((activity) => {
                  return {
                    id: activity.id,
                    weight: activity.weight,
                  }
                }),
              }
            }),
          }
        }),
      }
      const fetchFn = () => {
        this.$store
          .dispatch(`capability/submitCapabilityStep2`, params)
          .then((res) => {
            if (res.code === 1) {
              this.$message.success('保存成功')
              if (stepType === 2) {
                this.nextStep()
              } else if (stepType === 1) {
                this.indicatorFrom.indicatorList = []
                setTimeout(() => {
                  this.lastStep()
                }, 400)
              }
            }
          })
          .catch((err) => {
            console.log('err:', err)
          })
      }
      if (stepType === 2) {
        this.$refs.indicatorFrom.validate((valid) => {
          if (valid) {
            fetchFn()
          } else {
            return false
          }
        })
      } else {
        fetchFn()
      }
    },
    submitStepStep3(stepType) {
      let params = {
        course_id: this.courseId,
        is_submit: 1,
        show_mdl: this.previewForm.show_mdl,
      }
      this.$store
        .dispatch(`capability/submitCapabilityStep3`, params)
        .then((res) => {
          if (res.code === 1) {
            if (stepType === 1) {
              this.$message.success('保存成功')
              this.lastStep()
            } else if (stepType === 2) {
              this.$message.success('提交成功')
              this.$router.push({ name: 'abilityChart', query: { courseId: this.courseId } })
            }
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    removeTarget(item) {
      var index = this.ruleForm.list.indexOf(item)
      if (index !== -1) {
        this.ruleForm.list.splice(index, 1)
      }
    },
    addTarget() {
      this.ruleForm.list.push({
        indicator_name: '',
        description: '',
        level_id: this.evaluateList[0].id,
        content: [],
        key: Date.now(),
      })
      this.handleChangeLevel(this.evaluateList[0].id, this.ruleForm.list.length - 1)
    },
    // 修改能力框架
    editAbilityName() {
      this.$router.push({
        path: '/ability-framework/edit/' + this.ruleForm.id + '?courseId=' + this.courseId,
      })
    },
    // 关联主题
    relatedTopic(indicatorIndex) {
      this.dialogVisible = true
      this.indicatorItemDataIndex = indicatorIndex
      this.radioSection =
        this.indicatorFrom.indicatorList[this.indicatorItemDataIndex].section[0]?.type === '2' ? '2' : '1'
      setTimeout(() => {
        this.handleChangeSectionRadio(this.radioSection)
      }, 200)
    },
    // 添加评价项
    addEvaluationItem(indicatorIndex, { $index, row }) {
      this.indicatorItemDataIndex = indicatorIndex
      this.sectionItemDataIndex = $index
      this.checkedActivities = row.activity.map((item) => item.id)
      this.dialogEvaluateVisible = true
      this.getCapabilityConfigurationActivity()
    },
    // 切换课程主题和自定义主题
    handleChangeSectionRadio(val) {
      this.sectionList = []
      this.$refs?.multipleTopicTable?.clearSelection()
      if (val === '1') {
        this.getCapabilityConfigurationSection()
      } else {
        this.getCapabilitySectionList()
      }
    },
    // 主题选择
    handleSelectionChangeTopic(val) {
      this.multipleTopicSelection = val
      console.log('multipleTopicSelection', this.multipleTopicSelection)
    },
    handleCloseTopicDialog() {
      this.$refs.multipleTopicTable.clearSelection()
      this.handleSelectionChangeTopic([])
      this.dialogVisible = false
    },
    // 确认关联主题
    confirmRelatedTopic() {
      if(this.indicatorFrom.indicatorList[this.indicatorItemDataIndex].section.length === 0) {
        this.indicatorFrom.indicatorList[this.indicatorItemDataIndex].avg_section = 1
      }
      this.indicatorFrom.indicatorList[this.indicatorItemDataIndex].section = this.multipleTopicSelection.map(
        (item) => {
          let findSection = this.indicatorFrom.indicatorList[this.indicatorItemDataIndex].section.find(
            (v) => v.section_id == item.id
          )
          return {
            avg_activity: findSection ? findSection?.avg_activity : 1,
            section_id: item.id,
            name: item.name,
            activity: findSection?.activity || [],
            weight: findSection?.weight || '',
            type: this.radioSection,
          }
        }
      )
      this.handleCloseTopicDialog()
    },
    // 主题选择
    handleSelectionChangeActivity(val) {
      this.multipleEvaluateSelection = val
    },
    handleCloseEvaluateDialog() {
      // this.$refs.multipleEvaluateTable.clearSelection()
      this.dialogEvaluateVisible = false
    },
    // 确认关联评价项
    confirmRelatedEvaluate() {
      let flatData = flattenTree(this.tableActivityData)
      let templist = flatData.filter((item) => this.checkedActivities.includes(item.id))
      let copyActivity = [
        ...this.indicatorFrom.indicatorList[this.indicatorItemDataIndex].section[this.sectionItemDataIndex].activity,
      ]
      this.indicatorFrom.indicatorList[this.indicatorItemDataIndex].section[this.sectionItemDataIndex].activity =
        templist.map((item) => {
          let findActivity = copyActivity.find((activity) => activity.id === item.id)
          return {
            id: item.id,
            name: item.name,
            weight: findActivity ? findActivity.weight : '',
          }
        })
      this.handleCloseEvaluateDialog()
    },
    // 表单输入框阻止回车刷新页面
    handleEnter(event) {
      if (event.keyCode === 13) {
        event.preventDefault() // 阻止默认行为
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.configure {
  .text-small {
    font-size: 13px;
    color: #6c757d;
  }
  .font-bold {
    font-weight: bold;
  }
  .card-title {
    font-size: 18px;
    font-weight: bold;
  }
  .text-grey {
    color: #6c757d;
  }
  ::v-deep {
    .el-steps {
      .el-step__head {
        &.is-process,
        &.is-success {
          .el-step__icon.is-text {
            color: #fff;
            background-color: #409eff;
            border-color: #409eff;
          }
          .el-step__line-inner {
            border-color: #c0c4cc;
          }
        }
      }
      .el-step__title.is-process,
      .el-step__title.is-success {
        color: #409eff;
      }
    }
    .el-input {
      .el-input__suffix {
        line-height: 2.8;
      }
    }
    .btn-outline {
      background-color: #fff;
      &:focus,
      &:hover,
      &:active {
        color: #409eff;
      }
    }
    .el-form-item__label {
      font-size: 14px;
      color: #6c757d;
      font-weight: 500;
    }
  }
  .form-item-border {
    border-bottom: 1px solid #e6e6e6;
    ::v-deep {
      .el-form-item__content {
        .el-form-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          &__label {
            text-align: left !important;
            width: 100% !important;
            display: block;
          }
          &__content {
            margin-left: 0 !important;
          }
        }
      }
      .form-item-target-name {
        position: relative;
        .btn-remove {
          font-size: 14px;
          color: #e53939;
          position: absolute;
          top: -44px;
          right: 0;
        }
      }
    }
  }
  .comment-wrapper {
    .flex-left {
      width: 120px;
    }
    .flex-right {
      width: 0;
      flex: 1;
    }
  }
  ::v-deep .el-table {
    thead {
      th.el-table__cell {
        background-color: #f5f7fa;
        .cell {
          color: #343a40 !important;
          font-weight: bold;
          text-align: center;
        }
      }
    }
    tbody {
      .el-table__row {
        .el-table__cell {
          vertical-align: top;
          &.table-column-center {
            vertical-align: middle;
            .cell {
              text-align: center !important;
            }
          }
          .cell {
            color: #6c757d;
            .el-form-item {
              margin-bottom: 0;
              &__label {
                float: none;
              }
              &__content {
                float: right;
              }
            }
          }
        }
      }
    }
  }
  .preview-ability {
    ::v-deep {
      .el-form-item__label {
        line-height: 24px;
      }
      .el-form-item__content {
        line-height: 24px;
      }
    }
  }
}
</style>
